/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface Column {
  key: string;
  label?: string;
  presenter?: string;
  editable?: boolean;
  sortable?: boolean;
  customAttributeType: string;
}

export interface ColumnSize {
  name: string;
  size: number;
}

export type ColumnSizes = ColumnSize[];

export enum ColumnSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export interface ColumnSort {
  direction: ColumnSortDirection;
}

export interface DataRow {
  id: string;
}

export interface SortBy {
  by: string;
  direction: ColumnSortDirection;
}
